
import { createRequest, settingsRequest } from "@/common/helpers/RequestHelpers";

const documentsRequest = createRequest({
  urlPath: `/settings/documents`,
//   local: true,
});

const Types = {
    DOCUMENT_DOWNLOAD: "DOCUMENT_DOWNLOAD",
    DOCUMENT_DOWNLOADED: "DOCUMENT_DOWNLOADED",
    DOCUMENT_DOWNLOAD_FAILED: "DOCUMENT_DOWNLOAD_FAILED",
    DOCUMENT_DELETE: "DOCUMENT_DELETE",
    DOCUMENT_UPLOAD: "DOCUMENT_UPLOAD",
    DOCUMENT_GETTING_LIST: "DOCUMENT_GETTING_LIST",
    DOCUMENT_GET_LIST: "DOCUMENT_GET_LIST",
    DOCUMENT_EMAIL_SENDING: "DOCUMENT_EMAIL_SENDING",
    DOCUMENT_EMAIL_SENT: "DOCUMENT_EMAIL_SENT",
    DOCUMENT_EMAIL_FAILED: "DOCUMENT_EMAIL_FAILED",
}

const setDocuments = (documents) => ({
    type: Types.DOCUMENT_GET_LIST,
    documents,
});

const loadingDocuments = () => ({
    type: Types.DOCUMENT_GETTING_LIST,
});

/**
 * Get list of documents by type
 */
const getDocuments = (type) => {
    return async (dispatch, getState) => {
        dispatch(loadingDocuments());

        documentsRequest({
            method: "GET",
            path: type ? `/${type}` : ``,
        }).then(({ data }) => {
            dispatch(setDocuments(data));
        });
    }
}

const gettingAttachment = (id) => ({
    type: Types.DOCUMENT_DOWNLOAD,
    id,
});

const attachmentDownloaded = (payload, id, name) => ({
    type: Types.DOCUMENT_DOWNLOADED,
    id,
    payload,
    name,
});

/**
 * download document from server; first get the S3 signed URL then open it in a new tab
 * @param id
 */
const downloadDocument = (id) => {
    return (dispatch, getState) => {

        const state = getState();
        const document = state.documents.rows.find((doc) => doc.id == id);

        dispatch(gettingAttachment(id));
        documentsRequest({
            method: "GET",
            // /documents/:type/:id/pdf
            path: `/${document.type}/${id}/pdf`,
        }).then(({data}) => {
            dispatch(attachmentDownloaded(data, id, document.name));
        }).catch((error) => {
            dispatch({
                type: Types.DOCUMENT_DOWNLOAD_FAILED,
                id,
            });
        })
    }
}

const sendingDocument = (id) => ({
    type: Types.DOCUMENT_EMAIL_SENDING,
    id,
});

const documentSent = (payload, id) => ({
    type: Types.DOCUMENT_EMAIL_SENT,
    id,
    payload,
});

/**
 * Send document to server
 * @param id
 */
const sendDocument = (id) => {
    return (dispatch, getState) => {

        const state = getState();
        const document = state.documents.rows.find((doc) => doc.id == id);

        dispatch(sendingDocument(id));
        documentsRequest({
            method: "POST",
            // /documents/:type/:id/send
            path: `/${document.type}/${id}/send`,
        }).then(({data}) => {
            dispatch(documentSent(data, id));

        }).catch((error) => {
            dispatch({
                type: Types.DOCUMENT_EMAIL_FAILED,
                id,
            });
        })
    }
}

const Actions = {
    getDocuments,
    downloadDocument,
    sendDocument
};

export { Types, Actions };